import axios, { AxiosResponse } from 'axios'

import { PerformanceListResponse as ManualPerformanceListResponse } from '@/api/manual_types'

import {
  PerformanceCreate,
  PerformanceDetailedWrite,
  PerformanceId,
  PerformanceQueryParams,
  PerformanceRead,
  PerformanceReportRead,
  PerformanceReservationsRead,
  PerformanceWrite,
} from '@generated/types'

// Alias if manual type differs

const BASE_URL = '/api/performance'

export default {
  async fetchAll(
    query: PerformanceQueryParams,
  ): Promise<AxiosResponse<ManualPerformanceListResponse>> {
    // Use aliased manual type if needed
    const queryString = Object.entries(query)
      .map(entry => entry[0] + '=' + entry[1])
      .join('&')
    return axios.get(`${BASE_URL}/?${queryString}`)
  },

  async fetchReports(
    query: PerformanceQueryParams,
  ): Promise<AxiosResponse<PerformanceReportRead[]>> {
    const queryString = Object.entries(query)
      .map(entry => entry[0] + '=' + entry[1])
      .join('&')
    return axios.get(`${BASE_URL}/report/?${queryString}`)
  },

  async fetchOne(
    id: PerformanceId,
    query?: { invite_code: string },
  ): Promise<AxiosResponse<PerformanceRead>> {
    const queryString = Object.entries(query || {})
      .map(entry => entry[0] + '=' + entry[1])
      .join('&')
    return axios.get(`${BASE_URL}/${id}/?${queryString}`)
  },

  async create(data: PerformanceCreate): Promise<AxiosResponse<PerformanceRead>> {
    return axios.post(`${BASE_URL}/`, data)
  },

  async update(data: PerformanceWrite): Promise<AxiosResponse<PerformanceRead>> {
    // Ensure data.id exists before using it in the URL
    if (data.id === undefined || data.id === null) {
      return Promise.reject(new Error('Performance ID is required for update.'))
    }
    return axios.put(`${BASE_URL}/${data.id}/`, data)
  },

  async updateDetailed(data: PerformanceDetailedWrite): Promise<AxiosResponse<PerformanceRead>> {
    // Ensure data.id exists before using it in the URL
    if (data.id === undefined || data.id === null) {
      return Promise.reject(new Error('Performance ID is required for detailed update.'))
    }
    return axios.put(`${BASE_URL}/${data.id}/detailed/`, data)
  },

  async delete(id: PerformanceId): Promise<AxiosResponse> {
    return axios.delete(`${BASE_URL}/${id}/`)
  },

  async fetchReservations(id: PerformanceId): Promise<AxiosResponse<PerformanceReservationsRead>> {
    return axios.get(`${BASE_URL}/${id}/reservations/`)
  },

  async sendMassEmail(
    id: PerformanceId,
    subject: string,
    body: string,
  ): Promise<AxiosResponse<{ job_id: string }>> {
    return axios.post(`${BASE_URL}/${id}/mass_email/`, { subject, body })
  },

  async cancel(id: PerformanceId, refundAll: boolean): Promise<AxiosResponse> {
    return axios.post(`${BASE_URL}/${id}/cancel/`, { refund_all: refundAll })
  },
}
